package com.solevo.dist.repository.implementation.quotes

import com.solevo.dist.application.models.AnswerQuoteRequest
import com.solevo.dist.application.models.Product
import com.solevo.dist.application.models.Quote
import com.solevo.dist.application.models.QuoteRequest
import com.solevo.dist.application.models.SalesAgreementRequest
import com.solevo.dist.network.api.products.ProductRemoteSource
import com.solevo.dist.network.api.quotes.QuoteRemoteSource
import com.solevo.dist.repository.ApplicationQuoteRepository
import com.solevo.libraries.feature.authentication.accessToken.AccessTokenRemoteService
import kotlinx.coroutines.flow.Flow

class QuoteRepository(
    private val accessTokenRemoteService: AccessTokenRemoteService,
    private val quoteFirebaseRemoteSource: QuoteRemoteSource,
    private val quoteHttpRemoteSource: QuoteRemoteSource,
    private val productRemoteSource: ProductRemoteSource
): ApplicationQuoteRepository {
    override fun getQuotesLive(): Flow<List<Quote>> {
        return quoteFirebaseRemoteSource.getQuotesLive()
    }

    override fun getQuoteDetailsLive(quoteId: String): Flow<Quote?> {
        return quoteFirebaseRemoteSource.getQuoteDetails(quoteId)
    }

    override suspend fun markAsRead(quoteId: String) {
        quoteFirebaseRemoteSource.updateQuote(quoteId, true)
    }

    override suspend fun createQuote(quote: QuoteRequest): Result<Unit> = runCatching {
        val accessToken = accessTokenRemoteService.getAccessToken().getOrThrow()
        return quoteHttpRemoteSource.createQuote(quote, accessToken)
    }

    override suspend fun updateQuote(quote: QuoteRequest): Result<Unit> = runCatching {
        val accessToken = accessTokenRemoteService.getAccessToken().getOrThrow()
        return quoteHttpRemoteSource.updateQuote(quote, accessToken)
    }

    override suspend fun acceptQuote(quote: AnswerQuoteRequest): Result<Unit> = runCatching {
        val accessToken = accessTokenRemoteService.getAccessToken().getOrThrow()
        return quoteHttpRemoteSource.acceptQuote(quote, accessToken)
    }

    override suspend fun rejectQuote(quote: AnswerQuoteRequest): Result<Unit> = runCatching {
        val accessToken = accessTokenRemoteService.getAccessToken().getOrThrow()
        return quoteHttpRemoteSource.rejectQuote(quote, accessToken)
    }

    override suspend fun cancelQuote(quote: AnswerQuoteRequest): Result<Unit> = runCatching {
        val accessToken = accessTokenRemoteService.getAccessToken().getOrThrow()
        return quoteHttpRemoteSource.cancelQuote(quote, accessToken)
    }

    override suspend fun createSalesAgreement(salesAgreement: SalesAgreementRequest): Result<Unit> = runCatching {
        val accessToken = accessTokenRemoteService.getAccessToken().getOrThrow()
        return quoteHttpRemoteSource.createSalesAgreement(salesAgreement, accessToken)
    }

    override fun getProducts(ids: List<String>): Flow<List<Product>> {
        return productRemoteSource.getProducts(ids)
    }
}
